import { render, staticRenderFns } from "./OtherInfoViewer.vue?vue&type=template&id=18aaaeb6&scoped=true&"
import script from "./OtherInfoViewer.vue?vue&type=script&lang=ts&"
export * from "./OtherInfoViewer.vue?vue&type=script&lang=ts&"
import style0 from "./OtherInfoViewer.vue?vue&type=style&index=0&id=18aaaeb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aaaeb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRow})
